import ArticlePage from "@/pages/article/ArticlePage";

export default function VigorbuySpreadsheetGuide() {
  return <ArticlePage slug="vigorbuy-spreadsheet-guide" />;
}